import { React, useEffect, useState } from "react";
import API from '../../api/client';
import * as ENDPOINTS from '../../api/endpoints';
import { CustomerData } from '../utils/customers/CustomerData';
import Item from './Item';
import Slider from "react-slick"; 
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

export default function AnnouncementList() {
   const customer = CustomerData.getCustomer();
    const [whatsup, setWhatsup] = useState([]);

    useEffect(() => {
        // Add class '123' to body on mount
        document.body.classList.add('onetwothree');

        const response = API.getWithToken(ENDPOINTS.GET_WHATSUP_NON_FEATURED_ITEMS);
        response.then(res => { 
            if(res.statusText === 'OK') {
                setWhatsup(res.data.data.whatsup);
            }
        });

        return () => {
            // Cleanup function to remove class if component unmounts
            document.body.classList.remove('onetwothree');
        };
    }, []);

    useEffect(() => {
        const removeBodyClass = () => {
            document.body.classList.remove('onetwothree');
        };

        // Attach event listeners to slick slider navigation buttons
        const sliderArrows = document.querySelectorAll('.landingpage_slider .slick-arrow');
        sliderArrows.forEach(arrow => {
            arrow.addEventListener('click', removeBodyClass);
        });

        return () => {
            sliderArrows.forEach(arrow => {
                arrow.removeEventListener('click', removeBodyClass);
            });
        };
    }, [whatsup]);

      const sliderSettings = {
        dots: false,
        arrows:true,
        infinite: false,
        speed: 800,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 499,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    return (
        <>
            <div className="product-grid landingpage_slider">
                <Slider {...sliderSettings} className="landingpage_slider_l">
                {   whatsup &&
                    whatsup.map(item => (
                        <Item
                            key={item.id} {...item} customer={customer}/>
                    ))
                }
                 </Slider>
            </div>
        </>
    );
}
